import { useMemo } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const MODULES = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "blockquote"],
    ["clean"],
  ],
  clipboard: { matchVisual: false },
};

const FORMATS = [
  "header",
  "bold", "italic", "underline",
  "list",
  "link", "blockquote",
];

export const RichTextEditor = ({ value, onChange, placeholder = "Write here…" }) => {
  const modules = useMemo(() => MODULES, []);
  return (
    <div data-testid="rich-text-editor" className="quill-akyvia">
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={modules}
        formats={FORMATS}
        placeholder={placeholder}
      />
    </div>
  );
};

export default RichTextEditor;
